// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cmnmodel .modal-dialog{max-width:450px}.cmnmodel .btn-secondary{border-radius:5px;line-height:12px;min-height:auto;height:43px}.cmnmodel .btn{padding:9px 34px;font-size:16px}.icon-exp{border:2px solid #ffb300;color:#ffb300;width:60px;height:60px;margin:0 auto;border-radius:50%;font-size:32px;line-height:52px;margin-bottom:0}.modal-title{font-size:27px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
